﻿import type { AxiosRequestConfig, AxiosRequestHeaders } from 'axios'
import axios, { AxiosInstance } from 'axios';
import { useAuthenticationStore } from '@/stores/useAuthenticationStore'

export const eventsAuthenticatedAxios = axios.create({
    baseURL: import.meta.env.VITE_CONTENT_API
})
eventsAuthenticatedAxios.interceptors.request.use(async function (request: AxiosRequestConfig) {
    const authStore = useAuthenticationStore()

    let token = await authStore.getToken()
    ;(request.headers as AxiosRequestHeaders).Authorization = `Bearer ${token}`
    return request
})




// Create an Axios instance with global settings
const axiosInstance: AxiosInstance = axios.create({
 
  timeout: 10000, // Set the global timeout in milliseconds (e.g., 10 seconds)
  headers: {
    // Add any default headers you need
    'Content-Type': 'application/json',
  },
});

export default axiosInstance;